import type { TranslationKey } from '@/i18n/i18n';
import { cn } from '@/utils/cn';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterNavLink } from 'react-router';

import { useActiveRoute } from '../hooks/useActiveRoute';
import { NavBadge } from './NavBadge';

interface NavLinkProps {
  text: TranslationKey;
  to: string | undefined;
  className?: string;
  isUtilitySection?: boolean;
  badge?: boolean | string;
}

export const NavLink = ({ text, to, className, isUtilitySection = false, badge }: NavLinkProps) => {
  const { t } = useTranslation();
  const { isActive } = useActiveRoute(to);

  const shouldApplyActiveColor = isActive && !isUtilitySection;

  if (!to) {
    return (
      <div className="w-full">
        <div className="text-typography-100/50 flex w-full items-center justify-start gap-2 rounded-md px-3 py-1.5 text-left text-[13px] italic">
          {t(text)}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <RouterNavLink
        to={to}
        className={cn(
          'flex w-full items-center justify-start gap-2 rounded-md px-3 py-1.5 text-left text-[13px]',
          'transition-all duration-150 active:scale-95',
          shouldApplyActiveColor
            ? 'bg-primary/10 text-primary-100'
            : 'text-nav-item hover:bg-secondary-400/30 hover:text-typography',
          className
        )}
      >
        <span className="min-w-0 flex-1 truncate">{t(text)}</span>
        <NavBadge badge={badge} />
      </RouterNavLink>
    </div>
  );
};
